<template>
  <div>
    <div v-if="tab == 1" class="position-relative">
      <p class="font-weight-bold">
        Füllen Sie die nachstehenden Felder aus und laden Sie sich kostenlos unser Informationsmaterial herunter!
      </p>
      <div>
        <div class="form-row">
          <div class="form-group col">
            <div class="d-inline-flex justify-content-center align-items-center">
              <label class="mb-0 mr-3">Anrede wählen</label>
              <label class="check-container mb-0">Frau
                <input type="radio" name="salutation" id="salutation_frau" value="Frau" v-model="formData.salutation" />
                <span class="checkmark"></span>
              </label>
              <label class="check-container mb-0">Herr
                <input type="radio" name="salutation" id="salutation_herr" value="Herr" v-model="formData.salutation" />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="firstname">Vorname</label>
            <input type="text" class="form-control" id="firstname" v-model="formData.firstname" />
          </div>
          <div class="form-group col-md-6">
            <label for="lastname">Nachname</label>
            <input type="text" class="form-control" id="lastname" v-model="formData.lastname" />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label for="email">E-Mail*</label>
            <input type="email" class="form-control" id="email" v-model="formData.email" />
          </div>
        </div>
        <div class="form-row mb-3">
          <div class="form-group col m-0">
            <div class="
                d-inline-flex
                justify-content-center
                align-items-center
                h-100
                check-container
                pl-0
              ">
              <input type="checkbox" id="terms" value="accepted" v-model="formData.terms" required style="width: 1px" />
              <label for="terms" class="clickable-label">
                <small class="font-weight-bold">
                  Durch die Anforderung dieses Whitepapers bestätigen Sie,
                  dass Sie auch in Zukunft weitere Informationen von uns
                  zu dem Thema erhalten wollen. Diese Einwilligung erfolgt
                  freiwillig und kann von Ihnen jederzeit widerrufen werden.
                  Wir verarbeiten Ihre Daten datenschutzkonform. Details
                  finden Sie in unserer
                  <a href="/datenschutzerklaerung" target="_blank" class="text-black"><u>Datenschutzerklärung</u></a>.*
                </small>
              </label>
              <span class="checkmark"></span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <p>
              <small>*Pflichtfelder
              </small>
            </p>
          </div>
        </div>
        <div class="w-100  d-flex justify-content-center">
          <button id="sendData" @click.prevent="sendData" class="btn btn-primary text-uppercase font-weight-bold"
            :disabled="!formData.email ||
      !formData.terms ||
      loading
      ">
            Anfrage bestätigen
          </button>
        </div>
      </div>
      <div v-if="loading == true" class="loading-animation">
        <div class="w-100 h-100 d-flex justify-content-center align-items-center">
          <svg id="loading" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px" width="80px" height="80px" viewBox="0 0 40 40" enable-background="new 0 0 40 40"
            xml:space="preserve">
            <path opacity="0.2" fill="#000"
              d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
        s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
        c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z" />
            <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
        C22.32,8.481,24.301,9.057,26.013,10.047z">
              <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20"
                to="360 20 20" dur="0.5s" repeatCount="indefinite" />
            </path>
          </svg>
        </div>
      </div>
    </div>

    <div v-if="tab == 3" class="p-0 bg-white">
      <div class="">
        <div class="">
          <div class="d-flex justify-content-center">
            <div class="headline-strong-1 my-4 font-weight-bold">
              Vielen Dank!
            </div>
          </div>
        </div>
        <div class="">
          <div class="mb-md-4">
            <p class="mb-2">
              Ihre Anforderung weiterer Informationen zur Bauüberwachung ist bei
              uns eingegangen.
              <br /><br />
              <strong>Wir haben von Ihnen folgende Daten erhalten</strong>
            </p>
          </div>
        </div>

        <div class="">
          <div>
            <div>Vorname: {{ formData.firstname }}</div>
            <div>Nachname: {{ formData.lastname }}</div>
            <div>E-Mail: {{ formData.email }}</div>
            <br />
          </div>
        </div>

        <div class="mt-3">
          <div class="">
            <p>Sie erhalten in Kürze eine E-Mail, in der Sie Ihre E-Mail-Adresse bestätigen müssen.</p>
          </div>
        </div>

        <div class="mt-3">
          <div class="">
            <p>Viele Grüße<br />Ihr GSI SLV Team</p>
            <br />
          </div>
        </div>
      </div>
    </div>

    <div v-if="errorMessage" class="mt-3">
      <div v-if="memberExists === false" class="">
        <p class="font-weight-bold text-danger">
          Es ist ein Fehler aufgetreten.<br>Bitte versuchen Sie es erneut.
        </p>
      </div>
      <div v-if="memberExists === true" class="">
        <p class="font-weight-bold text-danger">
          Sie haben sich bereits angemeldet.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() { },
  data() {
    return {
      tab: 1,
      memberExists: false,
      errorMessage: false,
      loading: false,
      formData: {
        salutation: "",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        terms: null,
      },
    };
  },
  methods: {
    async sendData() {
      this.memberExists = false;
      this.loading = true;
      this.errorMessage = false;

      let self = this;

      // Recaptcha
      // Execute reCAPTCHA and get the token
      const token = await new Promise((resolve, reject) => {
        grecaptcha.ready(function () {
          grecaptcha.execute(window.recaptchaKey, { action: 'submit' }).then(token => {
            resolve(token);
          });
        });
      });

      const url = "/api/whitepaper-submit";
      const data = {
        email: this.formData.email,
        firstname: this.formData.firstname,
        lastname: this.formData.lastname,
        phone: this.formData.phone,
        salutation: this.formData.salutation,
        terms: this.formData.terms,
        formular: "Whitepaper",
        token
      };

      // Any issues -> console.log(response);
      axios
        .post(url, data)
        .then((response) => {
          self.loading = false;
          if (
            response.status === 200 &&
            response.data.status !== 400 &&
            response.data !== "Sie haben sich bereits registriert." &&
            response.data !== "Versuchen Sie es bitte erneut."
          ) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "whitepaperConversion",
              whitepaperConversion: "1",
            });
            self.tab = 3;
          } else {
            if (
              response.data.title === "Member Exists" ||
              response.data === "Sie haben sich bereits registriert."
            ) {
              self.memberExists = true;
            }
            self.errorMessage = true
          }
        })
        .catch(function (error) {
          self.errorMessage = true
          self.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "resources/sass/_variables.scss";

small {
  font-size: 0.8rem;
  line-height: 1rem;
}

h2 {
  font-size: 2.5rem;
}

#banner_thankyou {
  background-image: url("/images/wallpaper_thankyou.png");
  height: 455px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
}

.success-checkmark {
  width: 80px;
  height: 115px;
  margin: 0 auto;
}

.success-checkmark>.check-icon {
  width: 80px;
  height: 80px;
  position: relative;
  border-radius: 50%;
  box-sizing: content-box;
  border: 4px solid $blue;
}

.success-checkmark>.check-icon::before {
  top: 3px;
  left: -2px;
  width: 30px;
  transform-origin: 100% 50%;
  border-radius: 100px 0 0 100px;
}

.success-checkmark>.check-icon::after {
  top: 0;
  left: 30px;
  width: 60px;
  transform-origin: 0 50%;
  border-radius: 0 100px 100px 0;
  animation: rotate-circle 4.25s ease-in;
}

.success-checkmark>.check-icon::after,
.success-checkmark>.check-icon::before {
  content: "";
  height: 100px;
  position: absolute;
  background: #f7f7f7;
  transform: rotate(-45deg);
}

.success-checkmark>.check-icon>.icon-line {
  height: 5px;
  background-color: $blue;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
}

.success-checkmark>.check-icon>.line-tip {
  top: 46px;
  left: 14px;
  width: 25px;
  transform: rotate(45deg);
  animation: icon-line-tip 0.75s;
}

.success-checkmark>.check-icon>.line-long {
  top: 38px;
  right: 8px;
  width: 47px;
  transform: rotate(-45deg);
  animation: icon-line-long 0.75s;
}

.icon-circle {
  top: -4px;
  left: -4px;
  z-index: 10;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  box-sizing: content-box;
  border: 4px solid rgba(0, 155, 219, 0.5);
}

.icon-fix {
  top: 8px;
  width: 5px;
  left: 26px;
  z-index: 1;
  height: 85px;
  position: absolute;
  transform: rotate(-45deg);
  background-color: #f7f7f7;
}

@keyframes rotate-circle {
  0% {
    transform: rotate(-45deg);
  }

  5% {
    transform: rotate(-45deg);
  }

  12% {
    transform: rotate(-405deg);
  }

  100% {
    transform: rotate(-405deg);
  }
}

@keyframes icon-line-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }

  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }

  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }

  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }

  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}

@keyframes icon-line-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }

  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }

  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }

  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}

/* Success Checkmark */

svg path,
svg rect {
  fill: $orange;
}

.link {
  color: $black;
  font-weight: 700;
  text-decoration: none;
}

.link>img {
  margin-right: 5px;
  transition: all 0.2s ease-in-out;
}

.link:active>img {
  margin-right: 8px;
}

/* The container */
.check-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 25px;
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  user-select: none;
  height: 20px;
}

/* Hide the browser's default radio button */
.check-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.check-container input[type="radio"]~.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #f7f7f7;
  border-radius: 50%;
  border: 1px solid $black;
}

.check-container input[type="checkbox"]~.checkmark {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #f7f7f7;
  border: 1px solid $black;
  border-radius: 0.25rem;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  opacity: 0;
  transition: all 0.2s ease-in-out;
}

/* Show the indicator (dot/circle) when checked */
.check-container input:checked~.checkmark:after {
  opacity: 1;
}

/* Style the indicator (dot/circle) */
.check-container input[type="radio"]~.checkmark:after {
  top: 5px;
  left: 5px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: $black;
}

.check-container input[type="checkbox"]~.checkmark:after {
  top: 3px;
  left: 6px;
  width: 6px;
  height: 10px;
  border-right: 2px solid $black;
  border-bottom: 2px solid $black;
  transform: rotate(40deg);
}

@media (max-width: 767px) {
  h2 {
    font-size: 2rem;
  }
}

.loading-animation {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 2;
}
</style>
